const SCROLL_THRESHOLD = 300

export const updateBackToTopVisibility = () => {
  const buttons = document.querySelectorAll(".back-to-top")
  const visible = window.scrollY > SCROLL_THRESHOLD
  buttons.forEach(btn => btn.classList.toggle("d-none", !visible))
}
